import { createThunkRoutine } from 'redux-thunk-routine';
import {
  CREATE_CUSTOMER,
  GET_CUSTOMERS,
  GET_ORGANIZATION_WITH_CUSTOMERS,
  GET_CUSTOMER_LICENSES,
  GET_CUSTOMER_USERS,
  GET_CUSTOMER_USERS_ROLES,
  GET_CUSTOMER_ACCOUNT_REPRESENTATIVES,
  GET_CUSTOMER_APPLICATIONS,
} from './action-types';

export const CreateCustomerRoutine = createThunkRoutine(CREATE_CUSTOMER);
export const GetOrganizationsWithCustomersRoutine = createThunkRoutine(GET_ORGANIZATION_WITH_CUSTOMERS);
export const GetCustomersRoutine = createThunkRoutine(GET_CUSTOMERS);
export const GetCustomerUsersRoutine = createThunkRoutine(GET_CUSTOMER_USERS);
export const GetCustomerUsersWithRoleRoutine = createThunkRoutine(GET_CUSTOMER_USERS_ROLES);
export const GetAccountRepresentativesRoutine = createThunkRoutine(GET_CUSTOMER_ACCOUNT_REPRESENTATIVES);

export const GetCustomerLicensesRoutine = createThunkRoutine(GET_CUSTOMER_LICENSES);

export const GetCustomerApplicationsRoutine = createThunkRoutine(GET_CUSTOMER_APPLICATIONS);
